var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.provider !== 'PGSOFT')?_c('div',[(!_vm.change)?_c('iframe',{attrs:{"id":"game","src":_vm.gameLink},on:{"load":_vm.load}}):_vm._e()]):_c('div',[(!_vm.change)?_c('iframe',{attrs:{"width":"100%","height":"100%","frameborder":"0","scrolling":"no","srcdoc":_vm.gameLink},on:{"load":_vm.load}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }